module.exports = __webpack_public_path__ + "img/midtylland-logo-icon.9e300e70.png";